import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { genElText } from "../../../../components/utils/EditorDialogElementGenerator";

const CustomerDiscountSelectorFilter = (props) => {
  const { filterValue, setFilterValue, onClickRefresh } = props;

  const elName = genElText({
    field: 'name',
    name: 'Name',
    data: filterValue,
    setData: setFilterValue,
    error: {},
  });

  return (
    <div className="row-between-end gap-4 w-full">
      {/* filter component section */}
      <div className="row-start-center gap-4 w-full">
        {elName}
      </div>
      {/* refresh section */}
      <Button
        icon="pi pi-refresh"
        outlined
        rounded
        onClick={() => {
          if (onClickRefresh) onClickRefresh();
        }}
      />
    </div>
  );
};

export default CustomerDiscountSelectorFilter;
